export const styles = {
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginRight: '-50%',
    }
}